import axios from 'axios';

import Constants from '../utils/Constants';

export async function pushDatatoServer(resource, data, method){

    let token = getAccessToken();

    let api_key = getAPIKey();

    let headers={
        'x-auth-token': token, 
        apikey : api_key, 
        "Content-Type":"application/json"
    };

    let url = resource;
    let response = {};
    try{
        response = await axios({
            method: method,
            url: url,
            data: data,
            headers: headers
        });
        
    } catch(err){
        return err;
    }
    
    return response;
    
}

export async function checkValidToken(){

    let token = getAccessToken();

    let api_key = getAPIKey();

    let headers={
        'x-auth-token': token, 
        apikey : api_key, 
        "Content-Type":"application/json"
    };

    let url = '/api/auth';
    let response = {};
    try{
        response = await axios({
            method: 'get',
            url: url,
            headers: headers
        });
        
    } catch(err){
        return err;
    }

    return response;
    
}

export function deleteDataonServer(resource){
    let token = getAccessToken();
    let headers={
        'x-auth-token': token,
        "Content-Type":"application/json"
    };
    let url = resource;

    let config = {
        headers : headers
    }

    return axios.delete(url,config);

}

export function getAccessToken(){
    var token;

    if (localStorage.getItem("token")){
        token = localStorage.getItem("token");
    }
    else {
        token = "";
    }

    return token;

}

export function getAPIKey(){

    return Constants.API_KEY;

}

export function fileUploadtoServer(resource,file,method){

    let token = getAccessToken();

    let api_key = getAPIKey();

    let headers={
        'x-auth-token': token, 
        apikey : api_key, 
        "Content-Type":"multipart/form-data"
    };

    const formData = new FormData();
    formData.append('file',file);
    let url = resource;

    return axios({
        method:method,
        url:url,
        data:formData,
        headers:headers
    })
   .then(res => res.data)
   .catch (err => console.error(err))

}


export function deleteFileOnServer(data){

    let token = getAccessToken();

    let api_key = getAPIKey();

    let headers={
        'x-auth-token': token, 
        apikey : api_key, 
        "Content-Type":"application/json"
    };

    let url = '/api/file';

    return axios({
        method:'delete',
        url:url,
        data:data,
        headers:headers
    })
   .then(res => res.data)
   .catch (err => console.error(err))
    
}











export function myFileUploadtoServer(resource,file,method){

    let token = getAccessToken();

    let api_key = getAPIKey();

    let headers={
        'x-auth-token': token, 
        apikey : api_key, 
        "Content-Type":"multipart/form-data"
    };

    const formData = new FormData();
    formData.append('file',file);
    let url = resource;

    return axios({
        method:method,
        url:url,
        data:formData,
        headers:headers
    });
}


export function myDeleteFileOnServer(data){

    let token = getAccessToken();

    let api_key = getAPIKey();

    let headers={
        'x-auth-token': token, 
        apikey : api_key, 
        "Content-Type":"application/json"
    };

    let url = '/api/file';

    return axios({
        method:'delete',
        url:url,
        data:data,
        headers:headers
    })
    
}

